// removed by extract-text-webpack-plugin
module.exports = {"frame":"cms__PreviewPane__frame"};


//////////////////
// WEBPACK FOOTER
// ./components/PreviewPane/PreviewPane.css
// module id = 576
// module chunks = 0